import React from 'react';
import './BlogHero.css';
import heroImage from '../../../assets/Slide1.jpg';

const BlogHero = () => {
  return (
    <section
      className="blog-hero"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="blog-hero-overlay">
        <div className="page-container blog-hero-inner">
          <h1>Welcome to the Sonaroid Blog!</h1>
          <p>... for the African Energy Community</p>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
